import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  GuardResult,
  MaybeAsync,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { UserService } from '../shared/services/user.service';
import { ProfileService } from '../modules/profile/profile-edit/profile.service';
import { ProfileInfoPendingGuard } from './profile-info-pending.guard';

@Injectable({
  providedIn: 'root',
})
export class ProfileInfoFilledGuard implements CanActivate {
  constructor(
    private userService: UserService,
    private profileService: ProfileService,
    private router: Router
  ) {}
  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const user = await this.userService.getUserPromise();
    if (user.data.user?.id) {
      const hasFilled =
        await this.profileService.checkIfUserHasFullfiledPersonalInfo(
          user.data.user?.id
        );
      if (!hasFilled) {
        this.router.navigate(['profile']);
        return false;
      } else {
        return true;
      }
    }
    this.router.navigate(['profile']);
    return false;
  }
}
